<template>
  <div class="allocation-storehouse-detail-container">
    <ds-page-header :title="$t('allocationStorehouseDetail.page.title')" :subtitle="$t('allocationStorehouseDetail.page.subtitle')">
      <template #extra>
        <el-button type="primary" size="small" icon="el-icon-printer" @click="printAllocationStorehouse">
          {{ $t('allocationStorehouseDetail.print') }}
        </el-button>
        <el-button size="small" icon="el-icon-back" @click="callBackListPurchaseApply">
          {{ $t('common.back') }}
        </el-button>
      </template>
    </ds-page-header>

    <div class="ds-panel ds-panel--padded">
      <div class="ds-panel__header">
        <span class="ds-panel__title">{{ $t('allocationStorehouseDetail.applyInfo') }}</span>
        <ds-status-tag size="sm" type="muted" :label="allocationStorehouseDetailInfo.stateName || '-'" />
      </div>
      <div class="ds-info-grid">
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('allocationStorehouseDetail.applicant') }}</span>
          <span class="ds-info-grid__value">{{ allocationStorehouseDetailInfo.startUserName || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('allocationStorehouseDetail.applyTime') }}</span>
          <span class="ds-info-grid__value ds-num">{{ allocationStorehouseDetailInfo.createTime || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('allocationStorehouseDetail.type') }}</span>
          <span class="ds-info-grid__value">{{ allocationStorehouseDetailInfo.applyTypeName || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('allocationStorehouseDetail.status') }}</span>
          <span class="ds-info-grid__value">{{ allocationStorehouseDetailInfo.stateName || '-' }}</span>
        </div>
        <div class="ds-info-grid__item ds-info-grid__item--wide">
          <span class="ds-info-grid__label">{{ $t('allocationStorehouseDetail.applyRemark') }}</span>
          <span class="ds-info-grid__value">{{ allocationStorehouseDetailInfo.remark || '-' }}</span>
        </div>
      </div>
    </div>

    <div class="ds-panel">
      <ds-toolbar :show-column-setting="false" :show-density="false" :show-refresh="false">
        <template #left>
          <span class="ds-panel__title">{{ $t('allocationStorehouseDetail.allocationGoods') }}</span>
        </template>
      </ds-toolbar>
      <ds-data-table :data="allocationStorehouseDetailInfo.resourceStores" border
        :empty-description="$t('allocationStorehouseDetail.page.empty')">
        <el-table-column prop="resId" :label="$t('allocationStorehouseDetail.goodsId')" align="center" width="120">
          <template slot-scope="scope"><span class="ds-num">{{ scope.row.resId || '-' }}</span></template>
        </el-table-column>
        <el-table-column :label="$t('allocationStorehouseDetail.goodsType')" align="center" min-width="140">
          <template slot-scope="scope">
            {{ scope.row.parentRstName }} &gt; {{ scope.row.rstName }}
          </template>
        </el-table-column>
        <el-table-column prop="resName" :label="$t('allocationStorehouseDetail.goodsName')" align="center" min-width="140" />
        <el-table-column :label="$t('allocationStorehouseDetail.goodsSpec')" align="center" width="110">
          <template slot-scope="scope">
            {{ scope.row.specName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="resCode" :label="$t('allocationStorehouseDetail.goodsCode')" align="center" width="120">
          <template slot-scope="scope"><span class="ds-num">{{ scope.row.resCode || '-' }}</span></template>
        </el-table-column>
        <el-table-column prop="isFixedName" :label="$t('allocationStorehouseDetail.fixedGoods')" align="center" width="90" />
        <el-table-column
          :label="allocationStorehouseDetailInfo.applyType === '10000' || allocationStorehouseDetailInfo.applyType === '30000' ? $t('allocationStorehouseDetail.transferredWarehouse') : $t('allocationStorehouseDetail.returnPerson')"
          align="center" min-width="120">
          <template slot-scope="scope">
            {{ allocationStorehouseDetailInfo.applyType === '10000' || allocationStorehouseDetailInfo.applyType ===
              '30000' ? scope.row.shaName : allocationStorehouseDetailInfo.startUserName }}
          </template>
        </el-table-column>
        <el-table-column prop="shzName" :label="$t('allocationStorehouseDetail.targetWarehouse')" align="center" min-width="110" />
        <el-table-column
          :label="$t('allocationStorehouseDetail.originalStock') + '(' + (allocationStorehouseDetailInfo.applyType === '30000' ? $t('allocationStorehouseDetail.targetWarehouse') : $t('allocationStorehouseDetail.transferredWarehouse')) + ')'"
          align="center" width="140">
          <template slot-scope="scope">
            <span class="ds-num">{{ scope.row.originalStock }}{{ scope.row.unitCodeName }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('allocationStorehouseDetail.allocationQuantity')" align="center" width="130">
          <template slot-scope="scope">
            <span class="ds-num">{{ scope.row.stock }}{{ scope.row.applyType === '20000' ? scope.row.miniUnitCodeName :
              scope.row.unitCodeName }}</span>
          </template>
        </el-table-column>
      </ds-data-table>
    </div>

    <div v-if="allocationStorehouseDetailInfo.applyType === '10000' && allocationStorehouseDetailInfo.auditUsersCount > 0"
      class="ds-panel">
      <ds-toolbar :show-column-setting="false" :show-density="false" :show-refresh="false">
        <template #left>
          <span class="ds-panel__title">{{ $t('allocationStorehouseDetail.workflow') }}</span>
        </template>
      </ds-toolbar>
      <ds-data-table :data="allocationStorehouseDetailInfo.auditUsers" border
        :empty-description="$t('allocationStorehouseDetail.page.emptyFlow')">
        <el-table-column :label="$t('allocationStorehouseDetail.serialNumber')" align="center" width="80">
          <template slot-scope="scope">
            <span class="ds-num">{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('allocationStorehouseDetail.handler')" align="center" min-width="120">
          <template slot-scope="scope">
            {{ scope.row.userName || scope.row.auditName }}
          </template>
        </el-table-column>
        <el-table-column prop="stateName" :label="$t('allocationStorehouseDetail.status')" align="center" width="110">
          <template slot-scope="scope">
            <ds-status-tag size="sm" type="muted" :label="scope.row.stateName || '-'" />
          </template>
        </el-table-column>
        <el-table-column prop="auditTime" :label="$t('allocationStorehouseDetail.processTime')" align="center" width="170">
          <template slot-scope="scope"><span class="ds-num">{{ scope.row.auditTime || '-' }}</span></template>
        </el-table-column>
        <el-table-column prop="duration" :label="$t('allocationStorehouseDetail.timeConsuming')" align="center" width="110" />
        <el-table-column prop="message" :label="$t('allocationStorehouseDetail.opinion')" align="center" min-width="160" />
      </ds-data-table>
    </div>
    <div>
      <allocation-audit-div v-if="allocationStorehouseDetailInfo.action === 'audit'" ref="auditDiv" />
    </div>
  </div>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import {
  listAllocationStorehouseApplys,
  listAllocationStorehouses,
  listWorkflowAuditInfo
} from '@/api/resource/allocationStorehouseDetailApi'
import AllocationAuditDiv from '@/components/resource/allocationAuditDiv'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsToolbar from '@/components/ds/ds-toolbar.vue'
import DsDataTable from '@/components/ds/ds-data-table.vue'
import DsStatusTag from '@/components/ds/ds-status-tag.vue'

export default {
  name: 'AllocationStorehouseDetailList',
  components: {
    AllocationAuditDiv,
    DsPageHeader,
    DsToolbar,
    DsDataTable,
    DsStatusTag
  },
  data() {
    return {
      communityId: '',
      allocationStorehouseDetailInfo: {
        applyId: '',
        resourceStores: [],
        remark: '',
        startUserName: '',
        createTime: '',
        auditUsers: [],
        auditUsersCount: 0,
        stateName: '',
        applyType: '',
        applyTypeName: '',
        action: '',
        taskId: '',
        flowId: ''
      }
    }
  },
  created() {
    this.communityId = getCommunityId()
    this.allocationStorehouseDetailInfo.applyId = this.$route.query.applyId
    this.allocationStorehouseDetailInfo.applyType = this.$route.query.applyType
    this.allocationStorehouseDetailInfo.applyTypeName = this.$route.query.applyTypeName
    this.allocationStorehouseDetailInfo.action = this.$route.query.action
    this.allocationStorehouseDetailInfo.taskId = this.$route.query.taskId
    this.allocationStorehouseDetailInfo.flowId = this.$route.query.flowId
    this.listAllocationStorehouseApply()
    this.listPurchaseApply(1, 100)
  },
  methods: {
    async listPurchaseApply(page, rows) {
      try {
        const params = {
          page,
          row: rows,
          applyId: this.allocationStorehouseDetailInfo.applyId
        }
        const { data } = await listAllocationStorehouses(params)
        this.allocationStorehouseDetailInfo.resourceStores = data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    async listAllocationStorehouseApply() {
      try {
        const params = {
          page: 1,
          row: 1,
          applyId: this.allocationStorehouseDetailInfo.applyId
        }
        const { data } = await listAllocationStorehouseApplys(params)
        const purchaseApply = data[0]
        Object.assign(this.allocationStorehouseDetailInfo, purchaseApply)
        if (this.allocationStorehouseDetailInfo.applyType === '10000') {
          this.loadAuditUser()
        }
        if (this.allocationStorehouseDetailInfo.action === 'audit') {
          this.$nextTick(() => {
            if (this.$refs.auditDiv) {
              this.$refs.auditDiv.open({
                createUserId: purchaseApply.startUserId,
                action: this.allocationStorehouseDetailInfo.action,
                taskId: this.allocationStorehouseDetailInfo.taskId,
                flowId: this.allocationStorehouseDetailInfo.flowId,
                url: '/resourceStore.auditAllocationStoreOrder',
                id: purchaseApply.applyId,
              })
            }
          })
        }
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    async loadAuditUser() {
      try {
        const params = {
          businessKey: this.allocationStorehouseDetailInfo.applyId,
          communityId: this.communityId,
        }
        const { data } = await listWorkflowAuditInfo(params)
        this.allocationStorehouseDetailInfo.auditUsers = data
        this.allocationStorehouseDetailInfo.auditUsersCount = data.length
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    callBackListPurchaseApply() {
      this.$router.go(-1)
    },
    printAllocationStorehouse() {
      window.open(`/#/pages/property/printAllocationStorehouse?applyId=${this.allocationStorehouseDetailInfo.applyId}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.allocation-storehouse-detail-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}
.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;
  margin-bottom: var(--ds-spacing-lg);
  &--padded { padding: var(--ds-spacing-lg); }
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: var(--ds-spacing-md);
    margin-bottom: var(--ds-spacing-md);
    border-bottom: 1px solid var(--ds-gray-200);
  }
  &__title {
    font-size: var(--ds-font-size-lg);
    font-weight: 600;
    color: var(--ds-gray-800);
  }
}
.ds-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: var(--ds-spacing-md) var(--ds-spacing-lg);
  &__item {
    display: flex;
    flex-direction: column;
    gap: 4px;
    &--wide { grid-column: 1 / -1; }
  }
  &__label {
    font-size: var(--ds-font-size-sm);
    color: var(--ds-gray-500);
  }
  &__value {
    font-size: var(--ds-font-size-md);
    color: var(--ds-gray-800);
    word-break: break-all;
  }
}
</style>
